import {
  STAKES_SORT_KEYS,
  STAKES_SORT_TYPES,
  stakesQuickFilterConstants,
  sortKeys,
} from '../../pages/Stakes/stakesConstants';
import {
  getFilterPayloadValues,
  getShiftedDateFilterValue,
  isDateWithinRange,
} from '../../helpers/filterDate';
import { sortItemsByConfig } from '../../helpers/tableSort';
import * as types from './stakeActionTypes';

const initialState = {
  stakes: null,
  filteredStakes: null,
  stakesSortData: {
    sortType: STAKES_SORT_TYPES.DESCENDING,
    sortKey: STAKES_SORT_KEYS.START_DATE,
  },
  quickFilter: 1,
  error: {
    type: null,
    data: null,
  },
};

export const stakeReducer = (state = initialState, action) => {
  const sortStakesByCurrentSort = (
    stakes = [],
    sortData = state.stakesSortData
  ) => sortItemsByConfig(
    stakes,
    sortData,
    sortKeys,
    STAKES_SORT_TYPES.ASCENDING
  );

  switch (action.type) {
    case types.GET_STAKES_DATA:
      let stakes = action.payload.result
      return {
        ...state,
        stakes: stakes ? sortStakesByCurrentSort(stakes) : null,
      };

    case types.GET_STAKES_ERROR:
      return {
        ...state,
        error: {
          type: types.GET_STAKES_ERROR,
          data: action.payload,
        },
      };
    case types.FILTER_STAKES:
      function filterStakes(payload) {
        const { searchText, startDate, endDate } = getFilterPayloadValues(payload);
        const filteredStakes = [];
        let tempStakesForFilter = state.stakes;

        if (state.quickFilter === stakesQuickFilterConstants.STAKED) {
          tempStakesForFilter = tempStakesForFilter.filter((t) => t.claim_status === true )
        } else if (state.quickFilter === stakesQuickFilterConstants.DONE) {
          tempStakesForFilter = tempStakesForFilter.filter((t) => t.claim_status === false);
        }


        if (tempStakesForFilter) {
          for (const fStakes of tempStakesForFilter) {
            const matchesSearch = !searchText ||
              fStakes?.symbol?.toString().toLowerCase().includes(searchText) ||
              fStakes?.tx_hash?.toString().toLowerCase().includes(searchText) ||
              fStakes?.wallet?.toString().toLowerCase().includes(searchText);
            const stakeStartDate = getShiftedDateFilterValue(fStakes?.start_lock_time, -3);
            const matchesDate = isDateWithinRange(stakeStartDate, startDate, endDate);

            if (
              matchesSearch &&
              matchesDate
            ) {
              filteredStakes.push(fStakes);
            }
          }

          return filteredStakes;
        }
      }

      let filteredStakes = null;
      filteredStakes = filterStakes(action?.payload);

      return {
        ...state,
        filteredStakes: filteredStakes ? [...filteredStakes] : null,
      };
    case types.SET_STAKES_SORT_DATA:
      return {
        ...state,
        stakesSortData: { ...action.payload },
      };
    case types.SORT_STAKES:
      const tempStakesForSorting = state.filteredStakes?.length
        ? state.filteredStakes
        : state.stakes;
      const sortedStakes = sortStakesByCurrentSort(tempStakesForSorting);

      if (state.filteredStakes?.length) {
        return {
          ...state,
          filteredStakes: sortedStakes ? [...sortedStakes] : null,
        };
      }
      return {
        ...state,
        stakes: sortedStakes ? [...sortedStakes] : state.stakes,
      };
    case types.UPDATE_QUICK_FILTER:
      return {
        ...state,
        quickFilter: action?.payload,
      };
    default:
      return state;
  }
};
